export default {
  edit: "provider:edit",
  create: "provider:create",
  delete: "provider:delete",
  view: "provider:view",
};
